export default "__VITE_ASSET__12fe80c8__"